import { http } from '../../../../api/http';
import type { ProductoTipoBReport } from '../types';

export const productoTipoBService = {
  async getReport(): Promise<ProductoTipoBReport> {
    const response = await http.get('/produccion/Parte/productos-tipo-b/report');
    return response.data;
  },
};
